<template>
  <div class="details container main_top">
   <div class="details_container flex">
    <div class=" details_left">
      <div class="left_top">
     
        <div class='left_good flex'>
          <div class="good_img"><img :src="bannerPic" alt=""></div>
          <div class="good_info ">
            <div class="info_pop flex">
              <div class="pop_item flex_center">
                <div class="item_icon flex_center"><svg t="1731568841332" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15119" width="16" height="16"><path d="M152.673687 1023.904009c-22.429897 0-42.396025-17.27838-42.396026-41.948067 0-7.391307 2.495766-14.814611 4.991533-19.74215l239.305565-407.097834H127.748024c-22.429897 0-42.364028-17.27838-42.364029-41.948067 0-9.887073 2.495766-17.27838 7.455301-27.133457l299.139956-441.654595c14.942599-24.669687 49.851326-39.452301 79.768522-17.27838 29.917195 17.27838 27.421429 56.730681 12.446833 71.57729L239.89751 453.941443h219.339437c22.429897 0 42.396025 17.27838 42.396025 41.948067 0 7.391307-2.495766 14.814611-4.991532 19.74215l-149.553979 239.337562 436.183107-365.149768-266.694997 4.927538c-22.429897 0-42.396025-17.27838-42.396025-41.948067 0-9.887073 4.991532-19.742149 9.983064-29.597225l211.852139-222.059182h-74.77699c-22.429897 0-49.851326-19.742149-49.851326-51.803144 0-34.524763 27.421429-49.339374 47.35556-49.339374h211.884136c22.429897 0 42.364028 17.27838 42.364028 41.948067s-19.934131 39.452301-44.859794 61.690217l-184.462707 192.461957h316.546324c22.429897 0 42.364028 17.27838 42.364028 41.948067 0 12.318845-4.991532 27.133456-32.412961 46.875605L175.071587 1014.08093c-4.991532 4.959535-14.974596 9.887073-22.429897 9.887073z" p-id="15120" fill="#ffb700"></path></svg></div>
                <div class="Fast Delivery">{{ $t('key81') }}</div>
              </div>
              <div class="pop_item flex_center">
                <div class="item_icon flex_center"><svg t="1731568943427" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16265" width="16" height="16"><path d="M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 0.7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c0.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4c-6.4 8.8-19.6 8.8-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5 0.1 10.3 7.5 6.5 12.8z" p-id="16266" fill="#0075ff"></path></svg></div>
                <div class="Fast Delivery">{{ $t('key82') }}</div>
              </div>
              <div class="pop_item flex_center">
                <div class="item_icon flex_center"><svg t="1731569017707" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20080" width="16" height="16"><path d="M656.896 449.723733c-0.494933 0-0.938667 0.426667-1.4336 0.938667l-74.615467 101.410133c-0.768 0.733867-1.143467 1.809067-0.989866 2.8672 0 1.4336 0.989867 1.860267 2.850133 1.860267h75.861333v-104.260267c0.256-1.877333-0.750933-2.816-1.672533-2.816z" fill="#ff9500" p-id="20081"></path><path d="M511.6416 0.631467C305.083733 0.6144 118.8352 125.0304 39.765333 315.869867-39.287467 506.709333 4.4032 726.391467 150.459733 872.465067c146.0736 146.0736 365.738667 189.764267 556.5952 110.6944C897.8944 904.0896 1022.3104 717.841067 1022.293333 511.2832 1021.952 229.393067 793.531733 0.9728 511.6416 0.631467z m375.893333 252.416l12.817067-7.406934c16.861867-9.728 38.417067-3.959467 48.145067 12.9024 9.728 16.861867 3.959467 38.417067-12.9024 48.145067l-12.817067 7.406933c-16.861867 9.728-38.417067 3.959467-48.162133-12.9024-9.710933-16.861867-3.9424-38.417067 12.919466-48.145066zM476.398933 41.352533c0-19.473067 15.786667-35.242667 35.242667-35.242666 19.473067 0 35.242667 15.786667 35.242667 35.242666v14.7968c0 19.473067-15.786667 35.242667-35.242667 35.242667-19.473067 0-35.242667-15.786667-35.242667-35.242667v-14.7968z m-217.053866 32.256c16.861867-9.728 38.417067-3.959467 48.145066 12.9024l7.406934 12.817067c9.728 16.861867 3.959467 38.417067-12.9024 48.162133-16.861867 9.728-38.417067 3.959467-48.162134-12.9024l-7.406933-12.817066c-9.710933-16.861867-3.9424-38.434133 12.919467-48.162134zM42.154667 545.723733c-19.473067 0-35.242667-15.786667-35.242667-35.242666s15.786667-35.242667 35.242667-35.242667h14.7968c19.473067 0 35.242667 15.786667 35.242666 35.242667s-15.786667 35.242667-35.242666 35.242666H42.154667z m93.218133 222.549334l-12.817067 7.406933c-16.861867 9.728-38.417067 3.959467-48.145066-12.9024-9.728-16.861867-3.959467-38.417067 12.9024-48.145067l12.817066-7.406933c16.861867-9.728 38.417067-3.959467 48.162134 12.9024 9.728 16.861867 3.9424 38.417067-12.919467 48.145067z m13.090133-467.4048c-9.728 16.861867-31.300267 22.6304-48.162133 12.9024l-12.817067-7.406934c-16.861867-9.728-22.6304-31.2832-12.9024-48.145066 9.728-16.861867 31.300267-22.6304 48.145067-12.9024l12.817067 7.406933c16.878933 9.728 22.664533 31.2832 12.919466 48.145067z m166.109867 620.936533l-7.406933 12.817067c-9.728 16.861867-31.2832 22.6304-48.145067 12.9024-16.861867-9.728-22.6304-31.300267-12.9024-48.145067l7.406933-12.817067c9.728-16.861867 31.2832-22.6304 48.162134-12.9024 16.8448 9.728 22.613333 31.2832 12.885333 48.145067z m160.324267-232.772267a9.519787 9.519787 0 0 1-9.454934 9.454934H254.549333a9.494187 9.494187 0 0 1-9.437866-9.454934v-48.366933a148.61312 148.61312 0 0 1 64.4096-120.558933l43.52-31.095467c41.284267-28.910933 48.366933-32.699733 48.366933-54.971733 0-20.394667-11.8784-28.416-50.244267-28.416-28.910933 0-64.477867 3.293867-93.252266 6.212266h-1.1776a8.710827 8.710827 0 0 1-6.314667-2.9184 8.814933 8.814933 0 0 1-2.2016-6.6048v-36.488533c0-4.778667 4.283733-7.5776 9.0112-9.0112 32.8192-9.437867 66.7648-14.3872 100.9152-14.677333 87.04 0 120.866133 29.8496 120.866133 90.4704 0 38.417067-19.456 65.399467-54.528 89.088l-40.226133 27.050666c-40.2944 26.9824-68.7616 47.377067-68.7616 80.827734v1.928533h149.9648c2.4576-0.1024 4.846933 0.802133 6.621867 2.474667 1.774933 1.6896 2.798933 4.027733 2.833066 6.468266v48.5888z m71.6288 290.935467c0 19.473067-15.786667 35.242667-35.242667 35.242667s-35.242667-15.786667-35.242667-35.242667v-14.7968c0-19.473067 15.786667-35.242667 35.242667-35.242667s35.242667 15.786667 35.242667 35.242667v14.7968z m112.384-284.433067a9.161387 9.161387 0 0 1-2.525867-6.621866v-69.3248h-136.789333a9.454933 9.454933 0 0 1-6.690134-2.7648 9.454933 9.454933 0 0 1-2.7648-6.690134v-46.506666a25.2928 25.2928 0 0 1 5.1712-14.677334l149.777067-196.164266a14.206293 14.206293 0 0 1 12.4416-6.656h50.670933a9.557333 9.557333 0 0 1 9.506134 9.5232v201.130666h31.095466c5.2224 0.034133 9.454933 4.283733 9.454934 9.506134l-0.068267 43.4688c0 2.5088-0.989867 4.9152-2.7648 6.690133a9.454933 9.454933 0 0 1-6.690133 2.7648h-31.095467v69.700267c0.085333 2.4576-0.8192 4.846933-2.525867 6.621866a9.16992 9.16992 0 0 1-6.5024 2.833067h-63.232a9.183573 9.183573 0 0 1-6.468266-2.833067zM763.562667 947.712c-16.861867 9.728-38.417067 3.959467-48.145067-12.9024l-7.406933-12.817067c-9.728-16.861867-3.959467-38.417067 12.9024-48.162133 16.861867-9.728 38.417067-3.959467 48.162133 12.9024l7.406933 12.817067c9.728 16.861867 3.9424 38.434133-12.919466 48.162133z m13.243733-825.7536l-7.406933 12.817067c-9.728 16.861867-31.2832 22.6304-48.162134 12.9024-16.861867-9.728-22.6304-31.300267-12.9024-48.162134l7.406934-12.817066c9.728-16.861867 31.2832-22.6304 48.145066-12.9024 16.878933 9.745067 22.647467 31.300267 12.919467 48.162133z m171.52 641.143467c-9.728 16.861867-31.300267 22.6304-48.145067 12.9024l-12.817066-7.406934c-16.861867-9.728-22.6304-31.2832-12.9024-48.162133 9.728-16.861867 31.300267-22.6304 48.162133-12.9024l12.817067 7.406933c16.827733 9.745067 22.613333 31.300267 12.885333 48.162134z m32.443733-217.002667H965.973333c-19.473067 0-35.242667-15.786667-35.242666-35.242667s15.786667-35.242667 35.242666-35.242666h14.7968c19.473067 0 35.242667 15.786667 35.242667 35.242666s-15.786667 35.242667-35.242667 35.242667z" fill="#ff9500" p-id="20082"></path></svg></div>
                <div class="Fast Delivery">{{ $t('key23') }}</div>
              </div>
            </div>
            <div class="good_title">{{categoryTranName}}</div>
            <div class="info_pop flex" >
              <div class="pop_item flex_center">
                <div class="Fast Delivery" style="font-size: 14px;">{{ $t('key83') }}</div>
              </div>
              <div class="pop_item flex_center">
                <div class="Fast Delivery" style="font-size: 14px;">{{ $t('key84') }}: 100k+</div>
              </div>
              
            </div>
            <div class="good_rate flex_start_center">
                <div class="good_num">5.0</div>
                <div class="good_star"> <el-rate v-model="rateNum" disabled></el-rate></div>
                <!-- <div class="good_review">6,813</div> -->
              </div>
          </div>
        </div>
      </div>
      <div class="left_goods">
        <div class="goods_list ">
          <div class="goods_thumb " v-for="(item) in category" :key="item.id" @click=chooseItem(item) :class="[productId==item.id?'active_thumb':'']" >
            <div class="goods_thumb_content">
              <div class="goods_img"><img :src="item.upImage?item.upImage:item.image" alt=""></div>
              <div class="goods_info">
                <div class="goods_title">{{item.tranName}}</div>
                <div class="price_group flex_sb">
                  <div class="price_pay flex"><span>{{item.symbol}}</span>{{item.amount}}</div>
                  <div class="price_off">-{{item.symbol}}{{item.itemSavings}}</div>
                </div>
                <div class="price_show">{{item.symbol}}{{item.showAmount}}</div>
              </div>    
            </div>
            
          </div>
          <div v-for="i in 10" :key='i'> 
            <el-skeleton style="width:100%" :loading="categoryLoading" animated  >
            <template slot="template">
              <el-skeleton-item variant="image" style="width: 100%; height: 240px; background:#fff" />
              <div style="padding: 14px;">
                <el-skeleton-item variant="p" style="width: 50%" />
                <div style="display: flex; align-items: center; justify-items: space-between;">
                  <el-skeleton-item variant="text" style="margin-right: 16px;" />
                  <el-skeleton-item variant="text" style="width: 30%;" />
                </div>
              </div>
            </template>
          </el-skeleton>
          </div>
          
        </div>
        
      </div>
      <div class="goods_details" v-html="productDetails" v-if="productDetails"></div>
    </div>
    <!-- <div style="width:330px;min-width: 300px;" class="hidden-xs-only"></div> -->
    <div class=" details_right hidden-xs-only" ref="scroll">
      <div class="right_info ">
        <div class="info_title">{{ $t('key85') }}</div>
        <control-type :result="result" :transResult="transResult" v-if="hasResult&&!isMobile" @input="getObj"></control-type>
        <!-- <div class="info_form">
          <el-form label-position="top" label-width="80px" :model="payForm" ref="ruleForm" :rules="rules" >
            <el-form-item label="id" prop="id">
              <el-input v-model="payForm.id"></el-input>
            </el-form-item> 
            <el-form-item label="Server Region " prop="region">
              <el-select v-model="payForm.region" placeholder="">
                <el-option
                  v-for="item in regionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
        </el-form>
        </div> -->
        <div class="form_tips">
          <div class="tips_icon flex_center"><svg t="1731580505149" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4315" id="mx_n_1731580505150" width="16" height="16"><path d="M502.489 908.866c-217.49 0-395.195-177.706-395.195-395.195s177.706-395.195 395.195-395.195c217.49 0 395.195 177.706 395.195 395.195 0 217.49-177.706 395.195-395.195 395.195zM502.489 144.996c-201.577 0-368.672 167.094-368.672 368.672 0 204.227 164.444 368.672 368.672 368.672s368.672-164.444 368.672-368.672c0-201.577-164.444-368.672-368.672-368.672z" fill="#8a8a8a" p-id="4316"></path><path d="M507.795 670.156c-7.957 0-13.261-5.303-13.261-13.261v-387.239c0-7.957 5.303-13.261 13.261-13.261s13.261 5.303 13.261 13.261v387.239c0 7.957-5.303 13.261-13.261 13.261z" fill="#8a8a8a" p-id="4317"></path><path d="M507.795 800.118v0c-7.957 0-13.261-5.303-13.261-13.261v-13.261c0-7.957 5.303-13.261 13.261-13.261v0c7.957 0 13.261 5.303 13.261 13.261v13.261c0 5.303-5.303 13.261-13.261 13.261z" fill="#8a8a8a" p-id="4318"></path></svg></div>
          <div> {{ $t('key86') }}</div>
         
        </div>
      </div>
      <div class="right_payForm">
        <div class="count_content">
          <el-input-number v-model="payForm.count" :min="1" :max="9999999" @change="getCount()"></el-input-number>
        </div>
        <div class="price_group flex_sb">
          <div class="price_title">{{ $t('key27') }}</div>
          <div class="price_total">
            <div class="price_show">
              <span>{{symbol}}</span>
              <div>{{total}}</div>
            </div>
            <div class="price_sav ">{{ $t('key87') }} {{symbol}}{{savings}} </div>
          </div>
        </div>
        <div class="pay_btn flex_center" @click="toPay()">{{ $t('key88') }}</div>
        <div class="safe_tips flex_center">
          <div class="tips_icon"><img src='https://static.lootbar.gg/src/img/img_sp_shield.b6474022.png'></div>
          <div class="tips_text">{{ $t('key89') }}</div>
        </div>
      </div>
    </div>
   </div>
   
   <!-- mobile form input -->
  <div class="mobile_form "  v-if="mobileFormeVisble">
    <div class="right_info">
      <div class="info_title flex_sb">
        <div class="iconfont icon-back-line-free icon_back" @click="mobileFormeVisble=false"></div>
        <span> {{ $t('key85') }}</span>
        <span></span>
       </div>
      <div class="info_form">
        <control-type :result="result" :transResult="transResult" v-if="hasResult&&isMobile" @input="getObj"></control-type>
        <!-- <el-form label-position="top" label-width="80px" :model="payForm" ref="ruleForm2" :rules="rules" >
          <el-form-item label="id" prop="id">
            <el-input v-model="payForm.id"></el-input>
          </el-form-item> 
          <el-form-item label="Server Region " prop="region">
            <el-select v-model="payForm.region" placeholder="">
              <el-option
                v-for="item in regionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      </el-form> -->
      </div>
      <div class="info_bottom">
        <div class="form_tips">
          <div class="tips_icon flex_center"><svg t="1731580505149" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4315" id="mx_n_1731580505150" width="16" height="16"><path d="M502.489 908.866c-217.49 0-395.195-177.706-395.195-395.195s177.706-395.195 395.195-395.195c217.49 0 395.195 177.706 395.195 395.195 0 217.49-177.706 395.195-395.195 395.195zM502.489 144.996c-201.577 0-368.672 167.094-368.672 368.672 0 204.227 164.444 368.672 368.672 368.672s368.672-164.444 368.672-368.672c0-201.577-164.444-368.672-368.672-368.672z" fill="#8a8a8a" p-id="4316"></path><path d="M507.795 670.156c-7.957 0-13.261-5.303-13.261-13.261v-387.239c0-7.957 5.303-13.261 13.261-13.261s13.261 5.303 13.261 13.261v387.239c0 7.957-5.303 13.261-13.261 13.261z" fill="#8a8a8a" p-id="4317"></path><path d="M507.795 800.118v0c-7.957 0-13.261-5.303-13.261-13.261v-13.261c0-7.957 5.303-13.261 13.261-13.261v0c7.957 0 13.261 5.303 13.261 13.261v13.261c0 5.303-5.303 13.261-13.261 13.261z" fill="#8a8a8a" p-id="4318"></path></svg></div>
          <div> {{ $t('key86') }}</div>
        </div>
        <div class="btn_pay" @click="toPay()">{{ $t('key88') }}</div>
      </div>
    </div>
  </div>
   
    <!-- btn bottom -->
    <div class="bot_btnForm hidden-sm-and-up">
      <div class="flex_sb btnForm_group">
        <div class="group_title">{{ $t('key90') }}</div>
        <div class="count_group">
          <div class="count_content">
            <el-input-number v-model="payForm.count" :min="1" :max="9999999" @change="getCount()"></el-input-number>
          </div>
        </div>
      </div>
      <div class="flex_sb btnForm_group">
       <div class="price_box">
        <div class="price_title">{{ $t('key91') }}</div>
        <div class="price_amount">
          <span>{{symbol}}</span>
          <div>{{total}}</div>
        </div>
       </div> 
       <div class="btn_pay hidden-xs-only" @click="toPay()">{{ $t('key88') }}</div>
       <div class="btn_pay hidden-sm-and-up" @click="mobileBtn()">{{ $t('key88') }}</div>
      </div>
    </div>

    <!-- checkout -->
     <checkout :showDialog="showCheckout" @closeDialog="closeCheck" :orderId='orderId' :channelTag="channelTag" :shopName="shopName" :stripeKey="stripeKey" v-if="showCheckout"></checkout>
  </div>
</template>

<script>


import checkout from './checkout.vue';
import {divide} from '../../utils/tool'
import controlType from '../../components/controlType.vue';
import cookies from '../../utils/cookie';

export default {
 metaInfo(){
    return {
        title: this.$store.state.metaInfo.title,
        meta: [
            {
                name: "keywords",
                content: this.$store.state.metaInfo.keywords
            }, 
            {
              name: "description",
              content: this.$store.state.metaInfo.description
            }
        ]
    }
  },
  components:{
       checkout,
       controlType
  },
  data(){
    return{
      topHeight:0,
      rateNum:5,
      screenWidth:document.body.clientWidth,
      rules:{
        region: [{ required: true, message: 'region is required', trigger: 'blur' }],
        id: [{ required: true, message: 'UID is required', trigger: 'blur' } ],
      },
      payForm:{
        id:'',
        region:'',
        count:1,
      },
      paymenyForm:{},
      regionOptions:[
        {value:'America',label:'America'},{value:'Asia',label:'Asia'},{value:'Europe',label:'Europe'},
      ],
      showCheckout:false,
      mobileFormeVisble:false,
      goodsId:'',
      categoryImg:'',
      category:[],
      product:'',
      productId:'',
      productName:'',
      categoryLoading:true,
      total:0,
      savings:0,
      itemSavings:0,
      hasResult:false,
      isMobile:false,
      jsonObject:{},
      orderId:'',
      categoryTranName:'',
      symbol:'',
      bannerPic:'',
      categoryId:'',
      transResult:{},
      channelTag:'',
      shopName:'',
      stripeKey:'',
      productDetails:'',
    }
  },
  created(){
    let id = this.$route.params.id
    this.goodsId = id
    console.log('id',id,)
    this.getProduct()
  },
  methods:{
    // 获取模板
    getDate(){
      let lang =this.$store.state.lang
      let language = lang.dictValue
      let categoryId = this.categoryId
      this.$axiosApi.languageGoodTemplate({categoryId,language}).then(res=>{
          if(res.code == 200){
              let jsonObject = JSON.parse(res.data.content)
              // this.jsonObject = JSON.parse(jsonObject) 
              this.transResult = jsonObject.deliveryInfo.sections
              console.log('transResult',this.transResult)
              this.hasResult = true
              if(this.screenWidth<=768){
                this.isMobile = true
              }
          }
      })
    },
    getProduct(){
      let lang =this.$store.state.lang
      let currency = this.$store.state.currency
      
      let _this = this
      if(!lang||!currency){   
          setTimeout(()=>{
                _this.getProduct() 
          },1000)
          return
      }
      this.lang = lang
      this.currency = currency
      let categoryId = this.goodsId
      this.$axiosApi.getGoodsDetailList({categoryId}).then(res=>{
          if(res.code == 200){
            console.log('resss',res.data)
           this.categoryLoading = false
            res.data.map(v=>{
              if(!/^\s*$/.test(v.spare1)){
                v.spare1 = JSON.parse(v.spare1)
                v.spare1.map(s=>{
                  if(s.currency == currency.dictValue ){
                      v.showAmount =divide(s.showAmount) 
                      v.amount = divide(s.amount)
                      v.symbol = s.symbol
                      // console.log('spare1',v.spare1)
                      return
                  } 
                  if(s.currency =='1'){
                    console.log('currencyvvvvvvvvvvvvvvvv',v.amount)
                      v.showAmount =divide(s.showAmount) 
                      v.amount = divide(s.amount)
                      v.symbol = s.symbol
                  }
                })
              }
              if(!/^\s*$/.test(v.detailStr)){
                v.detailStr = JSON.parse(v.detailStr)
              } 
            
              let  itemSavings = (Number(v.showAmount)-Number(v.amount))
              v.itemSavings = divide(itemSavings*100)    
              if(!/^\s*$/.test(v.allName)){
                  v.allName = JSON.parse(v.allName)
                  v.allName.map(a=>{
                      if(a.language ==lang.dictValue ){
                          this.categoryTranName = a.name
                          this.productDetails = a.detail
                          return
                      }
                      if(a.language =='1' ){
                          this.categoryTranName = a.name
                          this.productDetails = a.detail
                          return
                      }
                  })
              }
              if(!/^\s*$/.test(v.upDetail)){
                v.upDetail = JSON.parse(v.upDetail)
                v.upDetail.map(c=>{
                  if(c.language == lang.dictValue ){  /* 获取包含当前语种商品详情 */
                   
                      v.tranName = c.name
                      this.shopName = c.name
                      return
                  } 
                  if(c.language == '1'){
                      v.tranName = c.name  
                      this.shopName = c.name
                  }
                }) 
              }
             
              this.category.push(v)
              return v
            })
              console.log('category',this.category,)
              let product=this.category[0]

               /* document title */
               let metaInfo = {}
               if(!/^\s*$/.test(product.spare3)){
                let title = product.spare3
                metaInfo.title = title
              }
              if(!/^\s*$/.test(product.spare4)){
                let description = product.spare4
                metaInfo.description = description
                metaInfo.keywords = this.categoryTranName
              }
              this.$store.commit('setMetaInfo',metaInfo)
              this.bannerPic = product.allNamePic
              this.categoryId = product.categoryId
              this.chooseItem(product)
              if(product.detailStr.preTradeDeliveryCollectionTemplateNeeded){
                this.getDate()
                if(!/^\s*$/.test(product.spare2)){
                  let spare2 = JSON.parse(product.spare2)
                  this.jsonObject = spare2
                  this.result = spare2.deliveryInfo.sections
                  // this.hasResult = true
                  // if(this.screenWidth<=768){
                  //   this.isMobile=true
                  // }
                  // this.languageAuto()
                  console.log('result',this.result)
                }
              }
              this.categoryImg =this.category[0].upImage
              // let attributes_id = res.data[0].id
              // this.selectItem(attributes_id)
              
          }
      })
    },
    chooseItem(item){
      console.log('itemmmm',item)
      this.productId = item.id
      this.product = item
      this.shopName = item.tranName
      this.getTotal()
      
    },
    getTotal(){
      let product = this.product
      let count = this.payForm.count
      let total = this.total
      let amount = product.amount
      let showAmount = product.showAmount
      let savings = this.savings
      let symbol = product.symbol
      this.symbol = symbol
      total = (Number(amount)*Number(count))
      let showTotal = (Number(showAmount)*Number(count))
      savings= showTotal - total
      this.total = divide(total*100) 
      this.savings = divide(savings*100)
      
      // console.log('total',this.total,this.savings)
    },
    getCount(){
      console.log('count',this.payForm.count)
      this.getTotal()
    },
    getObj(obj){
      let jsonObject = this.jsonObject
      jsonObject.deliveryInfo.sections = obj
      this.jsonObject = jsonObject
      console.log('obj',obj)
    },
    toPay(){
     let token = cookies.getToken()
   
     if(!token){
      this.$store.commit('setShowDialog',true)
      return
     }
      let goodsId = this.product.id
      let goodsNum = this.payForm.count
      let jsonObject = this.jsonObject

      let _this = this
      this.$axiosApi.createOrder({goodsId,goodsNum,jsonObject}).then(res=>{
        if(res.code == 200){
          let orderId = res.data.externalId
          this.orderId = orderId
          this.showCheckout = true
          this.channelTag = res.data.channelTag
          this.stripeKey = res.data.publicKey
         
     
        }
      })
    },
    getPaymentForm(form){
      this.paymentForm = form
    },
    
    mobileBtn(){
      this.mobileFormeVisble = true 
    },
    closeCheck(value){
      console.log('closeCheck',value)
      this.showCheckout = value
    },
   
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll)
  
    window.onresize = () => {
      this.screenWidth = window.innerWidth
    }
        
  },
  computed:{
    // lang(){return this.$store.state.lang},
    // currency(){return this.$store.state.currency}
  },
  watch: {
    screenWidth(newVal){
    
      // console.log('screenWidth',newVal)
        this.screenWidth = newVal;
        if(newVal<=768){
          this.isMobile = true
        }else{
          this.isMobile = false
          this.mobileFormeVisble = false
        }
        
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped> 
.details{
  height: 100%;
  position: relative;
  .details_container{
    margin-top:30px;
    position: relative;
    .details_left{
      // width: 70%;
      flex:1;
      .left_top{
        width: 100%;
        background:#fff;
        border-radius: 6px;
        padding:16px;
        .left_good{
          .good_img{
            width:96px;
            height: 96px;
            border-radius: 4px;
            overflow: hidden;
            margin-right:16px;
          }
          .good_info{
            text-align: left;
            .info_pop{
              .pop_item{
                color:#1f212899;
                font-size: 12px;
                line-height: 20px;
                padding-right:20px;
                position: relative;
                &::before{
                  position: absolute;
                  width: 1px;
                  height: 12px;
                  background: #e6e6e6;
                  content: "";
                  right: 10px;
                }
                &:last-child{
                  padding-right: 0;
                  &::before{
                    position: absolute;
                    width: 0px;
                    height: 0px;
                    background: #e6e6e6;
                    content: "";
                    right: 10px;
                  }
                }
                .item_icon{
                  width: 16px;
                  height: 16px;
                  margin-right:4px;
                }
              }
            }
          }
        }
        .good_title{
          color:#1f2128e6;
          font-size:18px;
          line-height: 26px;
        }
        .good_rate{
          margin:8px 0;
          .good_num{
            padding:0 4px;
            background:#fc0;
            color:#000000b2;
            margin-right:8px;
            font-size:12px;
            border-radius: 4px;
          }
          .good_star{
            /deep/.el-rate__icon{
              font-size: 20px;
              margin-right:1px;
            }
          }
          .good_review{
            color:#a5a6a9;
            font-size: 15px;
            margin-left:8px;
          }
        }
      }
      .left_goods{
        margin:20px 0;
        background: #fff;
        padding: 20px;
        border-radius: 6px;
        .goods_list{
          display: grid;
          
          grid-gap:8px;
          .active_thumb{
            border: 2px solid #ffcc32!important; 
          }
          .goods_thumb{
            border-radius: 4px;
            overflow: hidden;
            text-align: left;
            position: relative;
            box-sizing: border-box;
            // width:20%;
            // padding:0 8px 0px 0;
            margin-top:8px;
            border: 1px solid #e8eaf2;
            transform: translate(0);
            transition: all .1s linear;
            &:hover{
              transform: translateY(-2px);
              box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, .08), 0px 16px 24px 2px rgba(0, 0, 0, .04), 0px 6px 30px 5px rgba(0, 0, 0, .05);
            }
            .goods_thumb_content{
              background: #fff;
              width: 100%;
              overflow: hidden;
              border-radius: 4px;
              position: relative;
              padding-bottom: 55px;
            }
           .goods_info{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            position: absolute;
            bottom:0;
            left:0;
            right:0;
            min-height: 119px;
            background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff 64px, #fff);
           }
            .goods_img{
              // width:100%;
              height: 0;
              padding-top: 100%;
              position: relative;
              >img{
                display: block;
                position: absolute;
                max-width: 100%;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                transition: all .1s linear;
                height: 100%;
              }
            }
            .goods_title{
              padding:0 8px;
              color:#0f0f0f;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              font-size: 15px;
              line-height: 18px;
            }
            .price_group{
              padding:0 8px;
              .price_pay{
                align-items: baseline;
                font-size: 20px;
                color:#ff5000;
                font-weight: bold;
               
                >span{
                  font-size: 12px;
                }
              }
              .price_off{
                color:#fcfcfc;
                font-size: 12px;
                background:#ff8000;
                
                border-radius: 4px;
                padding:0 4px;
              }
              
            }
            .price_show{
              padding:0 8px 16px;
              font-size: 12px;
              text-decoration: line-through;
              color:#77808c;
              line-height: 16px;
            }
          }
        }
      }
      .goods_details{
        text-align: left;
        padding:16px;
        background: #fff;
        border-radius: 6px;
      }
      

    }
    .details_right{
      width:330px;
      min-width: 300px;
      padding-left:30px;
      // position:absolute;
      position: sticky;
       top: 110px;
       height: min-content;
      .right_info{
        padding:16px 16px 0;
        background:#fff;
        border-radius: 6px;
        text-align: left;
        .info_form{
          // padding-bottom:12px;
        }
        .info_title{
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 8px;
          color: rgba(31, 33, 40, .9);
        }
        /deep/.el-form-item__label{
          line-height: 0;
          padding:0;
        }
        /deep/.el-select{
          width: 100%;
        }
        /deep/.el-input__inner{
          background:#eff2f5;
          border:none;
          &:focus{
            border:1px solid #ffd633;
          }
        }
        .form_tips{
          padding: 10px 0;
          margin-left: -16px;
          margin-right: -16px;
          color: #000000b2;
          background: #fff5d5;
          display: flex;
          align-items: center;
          justify-content: center;
          .tips_icon{
            margin-right:20px;
          }
        }
      }
      .right_payForm{
        margin-top:20px;
        padding:16px;
        text-align: left;
        background:#fff;
        border-radius: 6px;
        .count_content{
          position:relative;
          /deep/.el-input-number {
            position:static;
            width:calc(100% - 100px);
          }
          /deep/.el-input{
            // width:calc(100% - 100px);
            margin-left:50px;
          }
          /deep/.el-input__inner{
            background:#eff2f5;
            border:none;
            &:focus{
              border:1px solid #ffd633;
            }
          }
          /deep/.el-input-number__increase {
            border-radius: 4px;
            border: 1px solid #DCDFE6;
          }
          /deep/.el-input-number__decrease {
            border-radius: 4px;
            border: 1px solid #DCDFE6;
          }
        }
        .price_group{
          padding-top:16px;
          .price_title{
            color:#0f0f0f;
            font-size:12px;
            font-weight:600;
          }
          .price_total{
            .price_show{
              display:flex;
              align-items: baseline;
              justify-content: flex-end;
              font-size:20px;
              font-weight: bold;
              color:#ff5000;
              text-align:right;
              >span{
                font-size:12px;
              }
            }
            .price_sav{
              background: linear-gradient(90deg, hsla(0, 0%, 100%, .15), rgba(255, 80, 0, .15) 55.59%);
              border-radius: 4px;
              color:#ff5000;
              font-size: 12px;
              text-align:right;
              cursor: pointer;
              display:flex;
              align-items: center;
              justify-content: flex-end;
            }
            
          }
          
        }
        .pay_btn{
          margin-top: 14px;
          width: 100%;
          height: 48px;
          font-size: 16px;
          background-color: #ffcb2e;
          border-radius: 4px;
          cursor: pointer;
        
        }
        .safe_tips{
          margin-top:12px;
          .tips_icon{
            width:16px;
            height:16px;
          }
          .tips_text{
            margin-left: 4px;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            text-transform: uppercase;
            color:#028300;
            // background: linear-gradient(180deg, #5cca5a, #028300);
          }
        }
      }

    }
  }
  .bot_btnForm{
    position: fixed;
    left:0;
    right:0;
    bottom:0;
    background-color: #fff;
    box-shadow: 0 5px 5px -3px rgba(0, 0, 0, .1), 0 8px 10px 1px rgba(0, 0, 0, .06), 0 3px 14px 2px rgba(0, 0, 0, .05);

    .btnForm_group{
      height: 48px;
      padding:0 16px;
      .group_title{
        color:#5e626b;
        font-size: 14px;
      }
      .price_box{
        color: #1f2128;
        font-size: 14px;
        text-align: left;
        .price_amount{
          display: flex;
          align-items: baseline;
          color:#ff5000;
          font-weight: 600;
          font-size:20px;
          >span{
            font-size:14px;
          }
        }
      }
      .btn_pay{
        background-color: #ffcb2e;
        width: 160px;
        height: 40px;
        cursor: pointer;
        text-align: center;
        line-height: 36px;
        padding: 0 16px;
        border-radius: 4px;
      }
      
    }
    .count_content{
      position:relative;
      max-width: 200px;
      /deep/.el-input-number {
        position:static;
        width:calc(100% - 100px);
      }
      /deep/.el-input{
        // width:calc(100% - 100px);
        // margin-left:50px;
      

      }
      /deep/.el-input__inner{
        background:#eff2f5;
        border:none;
        padding:0;
        &:focus{
          border:1px solid #ffd633;
        }
      }
      /deep/.el-input-number__increase {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        width: 38px;
        height: 38px;
        &:hover{
          color:#606266;
          /deep/.el-input__inner{
            
          }
        }
      }
      /deep/.el-input-number__decrease {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        width: 38px;
        height: 38px;
        &:hover{
          /deep/.el-input__inner{
            color:#606266;
            // border:1px solid transparent;
            
          
          }
        }
      }
    }
  }
  .mobile_form{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index: 99;
    background: #fff;
    // padding:16px;
    text-align: left;
    .right_info{
      height: 100%;
    }
    .info_title{
      height: 44px;
      padding:0 16px;
      border-bottom: 4px solid #eff2f5;
      font-weight: bold;
      .icon_back{
        cursor: pointer;
      }
    }
    .info_form{
      padding:16px;
      /deep/.el-form-item__label{
          line-height: 0;
          padding:0;
        }
        /deep/.el-select{
          width: 100%;
        }
        /deep/.el-input__inner{
          background:#eff2f5;
          border:none;
          &:focus{
            border:1px solid #ffd633;
          }
        }
       
    }
    .info_bottom{
      position: absolute;
      bottom:0;
      left: 0;
      right: 0;
      padding: 0 16px 16px;
    }
    .form_tips{
      padding: 10px 0;
      margin-left: -16px;
      margin-right: -16px;
      color: #000000b2;
      background: #fff5d5;
      display: flex;
      align-items: center;
      justify-content: center;
      .tips_icon{
        margin-right:20px;
      }
    }
    .btn_pay{
      margin-top:10px;
        background-color: #ffcb2e;
       
        height: 40px;
        cursor: pointer;
        text-align: center;
        line-height: 36px;
        padding: 0 16px;
        border-radius: 4px;
    }
  }
}


</style>